/* global $, ich */

const ich = require('./ICanHaz.min')

const jquery = require('./jquery-3.6.0.min')
window.$ = window.jQuery = jquery
require('./jquery-ui.min')

const SignatureBuilder = (function () {
  const accordion = $('#signature-builder')
  const form = $('#signature-details-form')
  const nameField = $('#name-field')
  const pronounField = $('#pronoun-field')
  const titleField = $('#title-field')
  const directPhoneField = $('#directphone-field')
  const mobileField = $('#mobile-field')
  const submit = $('#signature-details-submit')
  const outputHeader = accordion.find('h3').eq(1)
  const outputPreview = $('#output-preview')
  const divisionField = $('#division-field')

  const analogfolk = {
    name: 'AnalogFolk',
    domain: 'analogfolk.com',
    logo: 'https://d1l8gwq4hclih.cloudfront.net/logo-af.gif',
    styles: 'width:122px;height:30px;max-width:122px;',
  }
  const untoldfable = {
    name: 'Untold Fable',
    domain: 'untoldfable.com',
    logo: 'https://d1l8gwq4hclih.cloudfront.net/uf-logo@2x.gif',
    styles: 'width:120px;height:21px;max-width:120px;',
  }
  const otomo = {
    name: 'otomo',
    domain: 'otomo.io',
    logo: 'https://d1l8gwq4hclih.cloudfront.net/otomo_logo.png',
    styles: 'width:100px;height:22px;max-width:100px;',
  }

  const global = {
    name: 'AnalogFolk',
    domain: 'analogfolk.com',
  }

  const divisionData = {
    analogfolk: {
      ...analogfolk,
      logos: [analogfolk, untoldfable, otomo],
    },
    untoldfable,
    otomo,
    global: {
      ...global,
      logos: [analogfolk, untoldfable, otomo],
    },
  }

  const showAllLogos = ['global', 'analogfolk']

  function validateForm() {
    const name = nameField.val().trim()

    if (name.length === 0 || divisionField.val() === '') {
      submit.attr('disabled', 'disabled')
      accordion.accordion('disable')
      outputHeader.addClass('disabled')
      return false
    } else {
      submit.removeAttr('disabled')
      return true
    }
  }

  function generateOutput() {
    const formData = {}
    const division = divisionField.val()
    let output
    formData['name'] = nameField.val().trim()
    formData['pronoun'] = pronounField.val().trim()
    formData['title'] = titleField.val().trim()
    formData['directPhone'] = directPhoneField
      .val()
      .trim()
      .replace(/[^\+ ()0-9]+/g, '')
      .replace(/\s{2,}/g, ' ')
    formData['directPhoneLink'] = formData['directPhone'].replace(
      /[^\+0-9]+/g,
      ''
    )
    formData['mobilePhone'] = mobileField
      .val()
      .trim()
      .replace(/[^\+ ()0-9]+/g, '')
      .replace(/\s{2,}/g, ' ')
    formData['mobilePhoneLink'] = formData['mobilePhone'].replace(
      /[^\+0-9]+/g,
      ''
    )

    formData['divisionData'] = divisionData[division]

    const shouldShowAllLogos = showAllLogos.includes(division)

    if (division === 'global') {
      formData['isGlobal'] = true
    }

    if (shouldShowAllLogos) {
      formData['showAllLogos'] = true
    }

    output = ich.emailOutputTpl(formData)
    outputPreview.html(output)

    selectContents(outputPreview[0])
  }

  function generateSignature() {
    const formIsValid = validateForm()

    if (formIsValid) {
      generateOutput()
      accordion.accordion('enable')
      outputHeader.removeClass('disabled')
      outputHeader.click()
    }
  }

  function selectContents(element) {
    setTimeout(function () {
      let sel, range
      if (window.getSelection && document.createRange) {
        range = document.createRange()
        range.selectNodeContents(element)
        sel = window.getSelection()
        sel.removeAllRanges()
        sel.addRange(range)
      }
    }, 10)
  }

  function init() {
    accordion.accordion({
      heightStyle: 'content',
      icons: false,
    })
    accordion.accordion('disable')

    form.on('submit', function (e) {
      generateSignature()
      e.preventDefault()
    })

    form.on('reset', function () {
      accordion.accordion('disable')
      outputHeader.addClass('disabled')
      submit.attr('disabled', 'disabled')
    })

    generateSignature()

    nameField.on('keyup cut paste blur change', function () {
      validateForm()
    })

    outputPreview.on('click', function () {
      selectContents(this)
    })

    divisionField.on('change', function () {
      validateForm()
    })
  }

  return {
    init: function () {
      init()
    },
  }
})()

$(document).ready(function () {
  SignatureBuilder.init()
})
